module.exports = __webpack_public_path__ + "static/media/07_plantilla_cuadrada_combo_simple_cf_stills_tetra_1l_ades_almendras.24cac69c.png";